module.exports = __webpack_public_path__ + "static/media/freezeEffect.d4557efe.mp3";